// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  PRODUCTION: $ENV.PRODUCTION || false,
  COMMUNIC8_DOWNLOAD_API_URL: $ENV.COMMUNIC8_DOWNLOAD_API_URL || '4lyr43qwt1.execute-api.ca-central-1.amazonaws.com/qa',
  CONFIG_MANAGER_API_URL: $ENV.CONFIG_MANAGER_API_URL || 'localhost',
  CONFIG_MANAGER_API_PORT: $ENV.CONFIG_MANAGER_API_PORT || 3001,
  PROTOCOL: $ENV.PROTOCOL || "http",
  HTTP_REQUEST_DURATION: $ENV.HTTP_REQUEST_DURATION || 60000,

  TENANT: $ENV.TENANT || "authentication",
  ENVIRONMENT: $ENV.ENVIRONMENT || "development",
  LOGIN_URL: $ENV.LOGIN_URL || "https://hubio-dev.auth.ca-central-1.amazoncognito.com/login?client_id=80q9fi3avcu51o4f7gu2vir9c&response_type=code&scope=email+openid+phone+profile&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Flogin%2Fcallback%2F",
  LOGOUT_URL: $ENV.LOGOUT_URL || "https://hubio-dev.auth.ca-central-1.amazoncognito.com/logout?client_id=80q9fi3avcu51o4f7gu2vir9c&response_type=code&scope=email+openid+phone+profile&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2Flogin%2Fcallback%2F",
  HOMEPAGE_ROUTE: $ENV.HOMEPAGE_ROUTE || "/",
  REDIRECT_URL: $ENV.REDIRECT_URL || "http://localhost:4200/login/callback/",
  AUTH_URL: $ENV.AUTH_URL || "https://auth.uat.insuranceconnect.io:443/api/v1"
};
